







































































































interface Form {
  merchantId: string;
  apiKey: string;
  cert: string;
  certKey: string;
  pfx: string;
}
import { Component, Prop, Vue } from 'vue-property-decorator';
import SingleFileUpload from '@/component/single-file-upload.vue';
import { UPLOAD_CERT_API } from '@/constants';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const { VUE_APP_FCAPI: FCAPI } = process.env;

const UPLOAD_DIR = {
  cert: 'cert',
  key: 'key',
  pfx: 'pfx',
};
const API = {
  query: `${FCAPI}/shang/weixin/pay/cert`,
};

@Component({
  components: {
    SingleFileUpload,
  },
})
export default class PaymentBinding extends Vue {
  isLoading: boolean = false;
  formItemLayout: any = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  form: Form = getForm();
  isShowDialog: boolean = false;
  videoText: string = '';
  videoUrl: string = '';

  /*
   * 证书上传相关
   * cert 为私有 bucket 通过接口访问
   * 此处 UPLOAD_DOMAIN 用于适配接口
   * 保存数据时仅需保存文件相对路径
   */
  UPLOAD_CERT_API: string = UPLOAD_CERT_API;
  UPLOAD_DIR: any = UPLOAD_DIR;
  UPLOAD_DOMAIN: string = 'cert.liuliangphone.com';

  get merchant_id() {
    const profile = storage.getItem('profile') || {};
    return profile.merchant_id || '';
  }

  async query() {
    this.isLoading = true;
    const res: AxiosResponse = await this.$axios.get(
      API.query + '/' + this.merchant_id
    );

    const remote = res.data;
    if (remote.error) {
      this.$message.error(remote.message);
      this.isLoading = false;
      return;
    }
    this.form = getForm(remote.data);
    this.isLoading = false;
  }

  beforePemUpload(file: any) {
    if (file.name.substring(file.name.length - 4) !== '.pem') {
      this.$message.error('只能上传后缀为.pem的文件');
      return false;
    }
  }

  beforePfxUpload(file: any) {
    if (file.name.substring(file.name.length - 4) !== '.p12') {
      this.$message.error('只能上传后缀为.p12的文件');
      return false;
    }
  }

  showDialog(type: string) {
    this.videoText =
      type === '1' ? '如何获取商户号配置信息' : '如何关联小程序到商户';
    this.videoUrl =
      type === '1'
        ? '//v.tugou.com/qy/case/global-preview/JDpWeHQi7A.mp4'
        : '//v.tugou.com/qy/brand/video/hYTXwhKcWd.mp4';
    this.isShowDialog = true;
  }

  closeDialog() {
    this.videoUrl = '';
  }

  async submit() {
    const domainRegexp = new RegExp(
      `^.*${this.UPLOAD_DOMAIN.replace(/\./g, '\\.')}\\\/`
    );
    const sendData: any = {
      wx_merchant_id: this.form.merchantId,
      api_key: this.form.apiKey,
      cert: this.form.cert ? this.form.cert.replace(domainRegexp, '') : '',
      cert_key: this.form.certKey
        ? this.form.certKey.replace(domainRegexp, '')
        : '',
      pfx: this.form.pfx ? this.form.pfx.replace(domainRegexp, '') : '',
    };

    const res: AxiosResponse = await this.$axios.put(
      API.query + '/' + this.merchant_id,
      sendData
    );
    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      this.isLoading = false;
      return;
    }
    this.$message.success('保存成功');
    await this.query();
  }

  async created() {
    await this.query();
  }
}

function getForm(remote: any = {}): Form {
  return {
    merchantId: remote.wx_merchant_id,
    apiKey: remote.api_key,
    cert: remote.cert,
    certKey: remote.cert_key,
    pfx: remote.pfx,
  };
}
